import script from "./CatalogSearchInputFilter.vue?vue&type=script&setup=true&lang=ts"
export * from "./CatalogSearchInputFilter.vue?vue&type=script&setup=true&lang=ts"

import "./CatalogSearchInputFilter.vue?vue&type=style&index=0&id=ace54342&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ace54342"]])

export default __exports__